/* eslint-disable quotes */
export default Object.freeze({
  EDIT_TITLE: '그룹관리코드 설정',
  EDIT_NOTICE: '선택한 그룹관리코드 내 기존에 선택된 상품이 존재하는 경우, 기존에 선택한 상품은 유지된 상태로 선택한 상품이 추가됩니다.',

  EDIT_COLUMN_0: '그룹관리코드',
  EDIT_COLUMN_1: '노출명',

  EDIT_CODE_LIST_PLACEHOLDER: '영문, 숫자, 일부 특수문자(‘.’ ‘_’ ‘-’) 입력 가능',

  EDIT_ALERT_INSERT_CODE: '그룹관리코드를 입력해주세요.',
  EDIT_ALERT_MAX_PRODUCT_LENGTH: '상품 최대 개수를 초과하였습니다.\n1개 그룹관리코드에 상품은 최대 20개까지 설정 가능합니다.',
});
